import React, { forwardRef } from 'react';

const ServiceReportView = forwardRef(({ report }, ref) => {
  const logo = "https://customer-assets.emergentagent.com/job_hr-system-repair-1/artifacts/au3caisj_iSource%20LOGO.png";
  if (!report) return null;

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

  const inspectionItems = [
    { category: 'Document Feeder', items: ['Platen Roller', 'ADF pick-up roller', 'ADF feed roller', 'ADF separation pad'] },
    { category: 'Light Path', items: ['Copy board glass', 'Standard white plate', 'Lamp', 'Lens', 'Scanner Assembly'] },
    { category: 'Image Formation', items: ['Reading unit-upper', 'Reading unit-lower', 'Photodrum', 'Primary charging assembly', 'Developing assembly', 'Inter Transfer Belt', 'Transfer charging assembly', 'Drum/ITB cleaning assembly', 'Laser Assembly'] },
    { category: 'Fixing', items: ['Fixing roller/film unit', 'Pressure Roller', 'Cleaning Belt', 'Seperation claws'] },
    { category: 'Paper Path', items: ['Pick-up rollers', 'Separation rollers/pad', 'Delivery rollers', 'Duplex rollers'] },
    { category: 'Oth', items: ['Waste toner receptacle'] }
  ];

  const renderChecklistRow = (item) => {
    const status = report.inspection_checklist && report.inspection_checklist[item];
    return (
      <tr key={item} className="border-b border-black h-5">
        <td className="border-r border-black px-1 text-[9px] truncate max-w-[120px]">{item}</td>
        <td className="border-r border-black text-center text-[9px] w-8">{status === 'Good' ? '✓' : ''}</td>
        <td className="border-r border-black text-center text-[9px] w-8">{status === 'Faulty' ? '✓' : ''}</td>
        <td className="text-center text-[9px] w-8">{status === 'N/A' ? '✓' : ''}</td>
      </tr>
    );
  };

  return (
    <div className="bg-white p-6 min-h-full overflow-auto">
      <div ref={ref} className="max-w-[210mm] mx-auto bg-white text-black font-sans text-xs">
        
        {/* Header Section */}
        <div className="flex p-2">
          {/* Logo */}
          <div className="w-1/4 flex flex-col items-center justify-center">
            <img src={logo} alt="iSource Logo" className="w-full max-h-20 object-contain scale-125" />
          </div>

          {/* Main Office Info */}
          <div className="w-1/3 px-2 mx-2 text-[8px]">
            <p className="font-bold mb-1">Main Office & Showroom:</p>
            <p>497-B Imelda Bldg., Calbayog St.,</p>
            <p>Highway Hills, Mandaluyong</p>
            <p>1550</p>
            <div className="mt-1">
              <p>Tel. No.: (02) 8-7064477</p>
              <p>Mobile: (+63) 998-5315218</p>
            </div>
          </div>

          {/* Regional Office Info */}
          <div className="flex-1 px-2 text-[8px]">
            <p className="font-bold mb-1">Regional Office:</p>
            <div className="grid grid-cols-[auto_1fr] gap-x-2">
              <span>TUGUEGARAO:</span><span>Tel. No.: (078) 844-9920 Mobile: 0918-9232113</span>
              <span>LAGUNA:</span><span>Tel. No.: (049) 501-6938 Mobile: 0918-9229519</span>
              <span>BICOL:</span><span>Tel. No.: (054) 88-11-949 Mobile: 0947-1751294</span>
              <span>CEBU:</span><span>Tel. No.: (032) 239-7109 Mobile: 0950-3030274</span>
              <span>ILOILO:</span><span>Tel. No.: (033) 320-7049 Mobile: 0998-5315347</span>
              <span>TACLOBAN:</span><span>Mobile: 0968-8709145</span>
            </div>
          </div>
        </div>

        {/* Title and No. */}
        <div className="flex items-end justify-between px-4 py-1 mb-2">
          <h1 className="text-2xl font-bold">Service Report</h1>
          <div className="flex items-end text-lg font-bold">
            <span className="mr-2">No.</span>
            <span className="text-red-600">{report.fsr_number.toUpperCase()}</span>
          </div>
        </div>

        <div className="border border-black">

        {/* Info Grid - Top Section */}
        <div className="border-b border-black">
          {/* Row 1 */}
          <div className="flex border-b border-black h-5 pb-0.5">
            <div className="w-[30%] border-r border-black px-1 flex items-center text-[10px]">Call Received by: <span className="font-bold ml-1">{report.call_received_by}</span></div>
            <div className="w-[25%] border-r border-black px-1 flex items-center text-[10px]">Date Called: <span className="font-bold ml-1">{report.date_called}</span></div>
            <div className="w-[25%] border-r border-black px-1 flex items-center text-[10px]">Time Called: <span className="font-bold ml-1">{report.time_called}</span></div>
            <div className="flex-1 px-1 flex items-center text-[8px]">Response Time: (SC Only)</div>
          </div>

          {/* Row 2 - Customer Name */}
          <div className="flex border-b border-black h-6 pb-0.5">
            <div className="w-[70%] border-r border-black flex">
              <div className="px-1 flex items-center shrink-0 whitespace-nowrap text-[10px]">Customer Name:</div>
              <div className="flex-1 px-1 flex items-center font-bold bg-blue-50/30 text-[10px]">{report.account_name}</div>
            </div>
            <div className="w-[30%] flex">
              <div className="w-20 px-1 flex items-center shrink-0 text-[10px]">Caller Name:</div>
              <div className="flex-1 px-1 flex items-center text-[10px]">{report.contact_person}</div>
            </div>
          </div>

          {/* Row 3 - Address */}
          <div className="flex border-b border-black h-6 pb-0.5">
            <div className="w-[70%] border-r border-black flex">
              <div className="w-24 px-1 flex items-center shrink-0 text-[10px]">Address:</div>
              <div className="flex-1 px-1 flex items-center text-[9px] leading-tight">{report.address}</div>
            </div>
            <div className="w-[30%] flex">
              <div className="w-20 px-1 flex items-center shrink-0 text-[10px]">Tel:</div>
              <div className="flex-1 px-1 flex items-center text-[10px]">{report.contact_number}</div>
            </div>
          </div>

          {/* Row 4 - Model Name */}
          <div className="flex border-b border-black h-6 pb-0.5">
            <div className="w-[35%] border-r border-black flex">
              <div className="w-20 px-1 flex items-center shrink-0 text-[10px]">Model Name:</div>
              <div className="flex-1 px-1 flex items-center font-bold text-[10px]">{report.model}</div>
            </div>
            <div className="w-[35%] border-r border-black flex">
              <div className="w-20 px-1 flex items-center shrink-0 text-[10px]">Serial No.:</div>
              <div className="flex-1 px-1 flex items-center font-bold text-[10px]">{report.serial_number}</div>
            </div>
            <div className="w-[30%] flex">
              <div className="w-20 px-1 flex items-center shrink-0 text-[10px]">Fax:</div>
              <div className="flex-1 px-1 flex items-center"></div>
            </div>
          </div>

          {/* Row 5 - Defect Reported */}
          <div className="flex border-b border-black h-14">
            <div className="w-[35%] border-r border-black flex flex-col justify-center">
              <div className="px-1 text-[9px]">Defect Reported:</div>
              <div className="px-1 font-semibold text-[10px] leading-tight">{report.defect_reported}</div>
            </div>
            <div className="w-[35%] border-r border-black flex flex-col justify-center">
              <div className="px-1 text-[9px]">Present Meter Reading:</div>
              <div className="px-1 flex justify-center items-center text-base font-mono font-bold tracking-widest">
                {report.meter_reading_total}
              </div>
            </div>
            <div className="w-[30%] flex flex-col">
              <div className="px-1 text-[8px] text-center border-b border-black py-0.5">Call Type</div>
              <div className="flex-1 grid grid-cols-3 grid-rows-2 text-[7px] text-center">
                <div className="border-r border-b border-black flex items-center justify-center">SC</div>
                <div className="border-r border-b border-black flex items-center justify-center">CM</div>
                <div className="border-b border-black flex items-center justify-center">PM</div>
                <div className="border-r border-black flex items-center justify-center">INS</div>
                <div className="border-r border-black flex items-center justify-center">CC</div>
                <div className="flex items-center justify-center">OTH</div>
              </div>
            </div>
          </div>

          {/* Row 6 - Last Consumables Order */}
          <div className="flex h-6 pb-0.5">
            <div className="px-1 flex items-center shrink-0 border-r border-black whitespace-nowrap text-[10px]">Last Consumables Order:</div>
            <div className="flex-1 px-1 flex items-center text-[10px]">{report.last_consumables_order}</div>
          </div>
        </div>

        {/* Main Body Split */}
        <div className="flex border-t border-black min-h-[400px]">
          {/* Left Column - Work Details */}
          <div className="w-[60%] flex flex-col">
            {/* Work Done */}
            <div className="flex-1 p-2 border-b border-black min-h-[100px]">
              <div className="font-bold mb-1 text-[10px]">Work Done:</div>
              <p className="whitespace-pre-wrap text-[10px]">{report.work_done}</p>
            </div>

            {/* Machine Status */}
            <div className="h-8 border-b border-black flex items-center px-2 pb-0.5">
              <span className="mr-2 text-[10px]">Machine Status (State whether machine is working or not working):</span>
              <span className="font-bold ml-auto text-[10px]">{report.status === 'Completed' ? 'Working' : report.status}</span>
            </div>

            {/* Parts List */}
            <div className="flex-1 border-b border-black flex flex-col">
              <div className="flex border-b border-black h-5 items-center px-2 bg-gray-100 pb-0.5">
                <span className="font-bold mr-4 text-[10px]">Parts List</span>
                <div className="flex items-center gap-4 text-[9px]">
                  <div className="flex items-center"><div className="w-2.5 h-2.5 border border-black mr-1 bg-black"></div> Replaced</div>
                  <div className="flex items-center"><div className="w-2.5 h-2.5 border border-black mr-1"></div> For Replacement</div>
                </div>
                <span className="ml-auto font-bold text-[9px]">Qty.</span>
              </div>
              {/* Parts Rows */}
              <div className="flex-1">
                {report.parts_replaced && report.parts_replaced.length > 0 ? (
                  report.parts_replaced.map((part, i) => (
                    <div key={i} className="flex border-b border-gray-300 h-5 items-center px-2 text-[9px] pb-0.5">
                      <div className="w-4 flex justify-center mr-2">
                        {part.part_status === 'Replaced' ? (
                          <div className="w-2.5 h-2.5 border border-black bg-black"></div>
                        ) : (
                          <div className="w-2.5 h-2.5 border border-black"></div>
                        )}
                      </div>
                      <span className="flex-1 truncate">{part.name}</span>
                      <span className="w-8 text-center border-l border-gray-300">{part.quantity}</span>
                    </div>
                  ))
                ) : (
                  <div className="h-full flex items-center justify-center text-gray-400 italic text-[9px]">No parts listed</div>
                )}
                {/* Empty rows filler if needed */}
                {Array.from({ length: Math.max(0, 5 - (report.parts_replaced?.length || 0)) }).map((_, i) => (
                  <div key={`empty-${i}`} className="flex border-transparent h-5 items-center px-2 pb-0.5"></div>
                ))}
              </div>
            </div>

            {/* Footer Info */}
            <div className="flex border-b border-black h-6 text-[9px] pb-0.5">
              <div className="flex-1 border-r border-black flex items-center px-1">
                <span className="mr-1">Date:</span>
                <span className="font-bold">{report.date}</span>
              </div>
              <div className="w-24 border-r border-black flex items-center px-1">
                <span className="mr-1">Time In:</span>
                <span className="font-bold">{report.time_in}</span>
              </div>
              <div className="w-24 flex items-center px-1">
                <span className="mr-1">Time Out:</span>
                <span className="font-bold">{report.time_out}</span>
              </div>
            </div>

            {/* Service Engineer */}
            <div className="h-6 border-b border-black flex items-center px-2 text-[9px] pb-0.5">
              <span className="mr-2">Service Engineer:</span>
              <span className="font-bold uppercase">{report.technician_name}</span>
            </div>

            {/* Disclaimer & Signature */}
            <div className="h-20 p-2 flex flex-col justify-between">
              <p className="text-[8px] text-center italic">I hereby acknowledge the services rendered described in this report.</p>
              
              <div className="flex flex-col items-center mt-1 relative">
                {report.customer_signature && (
                  <img 
                    src={report.customer_signature.startsWith('http') ? report.customer_signature : `${BACKEND_URL}${report.customer_signature}`} 
                    alt="Signature" 
                    className="h-10 object-contain absolute bottom-3"
                  />
                )}
                <div className="w-3/4 border-b border-black mt-6"></div>
                <p className="text-[8px] mt-0.5">Customer Signature over Printed Name / Date</p>
              </div>
            </div>
          </div>

          {/* Right Column - Checklist */}
          <div className="w-[40%] flex flex-col text-[9px] border-l border-black">
            <table className="w-full border-collapse">
              <thead>
                <tr className="h-5 bg-gray-100">
                  <th className="border-b border-r border-black text-center font-normal w-[15px]"></th>
                  <th className="border-b border-r border-black text-left px-1 font-bold">Inspection Checklist</th>
                  <th className="border-b border-r border-black text-center w-7 font-bold text-[8px]">Good</th>
                  <th className="border-b border-r border-black text-center w-7 font-bold text-[8px]">Faulty</th>
                  <th className="border-b border-black text-center w-7 font-bold text-[8px]">N/A</th>
                </tr>
              </thead>
              <tbody>
                {inspectionItems.map((category) => (
                  <React.Fragment key={category.category}>
                    {category.items.map((item, index) => (
                      <tr key={item} className="h-5">
                        {index === 0 && (
                          <td 
                            rowSpan={category.items.length} 
                            className="border-r border-b border-black text-center bg-gray-50 align-middle p-0"
                          >
                            <div className="h-full flex items-center justify-center w-full">
                              <div className="transform -rotate-90 whitespace-nowrap text-[6px] font-bold uppercase tracking-wider origin-center">
                                {category.category}
                              </div>
                            </div>
                          </td>
                        )}
                        <td className="border-r border-b border-black px-1 pb-0.5 truncate max-w-[100px] align-middle">{item}</td>
                        <td className="border-r border-b border-black text-center pb-0.5 align-middle">
                          {report.inspection_checklist?.[item] === 'Good' ? '✓' : ''}
                        </td>
                        <td className="border-r border-b border-black text-center pb-0.5 align-middle">
                          {report.inspection_checklist?.[item] === 'Faulty' ? '✓' : ''}
                        </td>
                        <td className="border-b border-black text-center pb-0.5 align-middle">
                          {report.inspection_checklist?.[item] === 'N/A' ? '✓' : ''}
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
});

export default ServiceReportView;